import { Injectable, StateKey, TransferState } from '@angular/core';
import { makeStateKey } from '@angular/core';

// const DATA_KEY = makeStateKey<any>('preloadedData');

@Injectable({
  providedIn: 'root'
})
export class PrerenderDataService {

  constructor(private transferState: TransferState) {}

  getPreloadedData( DATA_KEY:StateKey<any>): any {
    return this.transferState.get(DATA_KEY, null);
  }

  setPreloadedData(DATA_KEY:StateKey<any>,data: any) {
    this.transferState.set(DATA_KEY, data);
  }
}
